import { render, staticRenderFns } from "./ArticleProductFastStore.vue?vue&type=template&id=0b5131ac"
import script from "./ArticleProductFastStore.vue?vue&type=script&lang=js"
export * from "./ArticleProductFastStore.vue?vue&type=script&lang=js"
import style0 from "./ArticleProductFastStore.vue?vue&type=style&index=0&id=0b5131ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports